import { render } from "./legoSlider.vue?vue&type=template&id=f07da050"
import script from "./legoSlider.vue?vue&type=script&lang=js"
export * from "./legoSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoSlider/legoSlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f07da050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f07da050', __exports__)) {
    api.reload('f07da050', __exports__)
  }
  
  module.hot.accept("./legoSlider.vue?vue&type=template&id=f07da050", () => {
    api.rerender('f07da050', render)
  })

}


export default __exports__